<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.5" cy="16.5" r="6.5" fill="#D9D9D9" />
    <circle cx="12.5" cy="16.5" r="6.5" :fill="`url(#${componentId}_paint0_linear_4224_1686)`" />
    <foreignObject x="-1" y="-1" width="26" height="22"><div xmlns="http://www.w3.org/1999/xhtml" :style="`backdrop-filter:blur(1px);clip-path:url(#${componentId}_bgblur_0_4224_1686_clip_path);height:100%;width:100%`" /></foreignObject><g :filter="`url(#${componentId}_filter0_i_4224_1686)`" data-figma-bg-blur-radius="2">
      <path d="M23 10L12 1L1 10L12 19L23 10Z" :fill="`url(#${componentId}_paint1_linear_4224_1686)`" fill-opacity="0.48" />
    </g>
    <path d="M1 10L1.5 19H0.5L1 10Z" :fill="`url(#${componentId}_paint2_linear_4224_1686)`" fill-opacity="0.48" />
    <defs>
      <filter
        :id="`${componentId}_filter0_i_4224_1686`"
        x="-1"
        y="-1"
        width="26"
        height="22"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="0.047683" dy="0.0238415" />
        <feGaussianBlur stdDeviation="0.119208" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4224_1686" />
      </filter>
      <clipPath :id="`${componentId}_bgblur_0_4224_1686_clip_path`" transform="translate(1 1)"><path d="M23 10L12 1L1 10L12 19L23 10Z" />
      </clipPath><linearGradient
        :id="`${componentId}_paint0_linear_4224_1686`"
        x1="19.2955"
        y1="23.2639"
        x2="10.9036"
        y2="5.31861"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4646FB" />
        <stop offset="0.5" stop-color="#BE4DFF" />
        <stop offset="1" stop-color="#BC9AFF" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint1_linear_4224_1686`"
        x1="23.5"
        y1="20.6364"
        x2="12.1539"
        y2="-7.09866"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4646FB" />
        <stop offset="0.5" stop-color="#BE4DFF" />
        <stop offset="1" stop-color="#BC9AFF" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint2_linear_4224_1686`"
        x1="1.52273"
        y1="19.8182"
        x2="-1.90539"
        y2="19.0564"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4646FB" />
        <stop offset="0.5" stop-color="#BE4DFF" />
        <stop offset="1" stop-color="#BC9AFF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    componentId: {
      type: String,
      default: ''
    }
  }
}
</script>
